export function normalizeData({
  type_keys,
  property,
  formData: { drawers_id, keyset_quantity, keys },
}: any) {
  const normalizedKeys: {
    [key: string]: {
      type_keys_id: number;
      quantity: number;
      serial_number: string;
    };
  } = {};

  type_keys.forEach((typeKey: { id: number; name: string }) => {
    const keyName = typeKey.name;
    const typeKeyId = typeKey.id;
    const keyInfo = keys.find(
      (key: { type_key_id: number }) => key.type_key_id === typeKeyId
    );
    const quantity = keyInfo ? keyInfo.quantity : 0;
    const serialNumber = keyInfo ? keyInfo.serial_number : '';

    normalizedKeys[keyName] = {
      type_keys_id: typeKeyId,
      quantity: quantity,
      serial_number: serialNumber,
    };
  });

  return {
    country: process.env.REACT_APP_ENV_COUNTRY,
    properties_nid: property.nid,
    drawers_id,
    keys: {
      ...normalizedKeys,
      'Juego de llaves': {
        type_keys_id: 1,
        quantity: keyset_quantity,
        serial_number: keys.serial_number,
      },
    },
  };
}
